//Libreria para el uso de alertas
import Swal from 'sweetalert2'
import { store } from "../store/store";
//Se importan los types de cada acción para usar los que se requieran
import { types } from '../types/types'
//Libreria para las animaciones de Sweetalert2
import "animate.css"
//Libreria para realizar conversiones entre fechas
import * as moment from 'moment'
import 'moment/locale/es'
import 'moment-timezone'
import axios from "axios";
import {
	getTimeStampCorregidoZonaHorariaCH,
} from "./actionsTime";

//Método que set las citas peritajes filtradas
export const setDatesPeritaje = (dates) => ({
	type: types.loadDatesPeritaje,
	payload: dates
});

//Método que set las citas de peritaje en toda la BD
export const setFullDatesPeritaje = (dates) => ({
	type: types.loadFullDatesPeritaje,
	payload: dates
});

//Método para agregar Enlace al Peritaje
// export const addLinkPeritaje = (uid, data, emailPatient, phonePatient) => {
export const addLinkPeritaje = (uid, data, emailPatient) => {
	const reduxState = store.getState().company;
	const db = reduxState?.companyInstance?.db;
	const urlServer = reduxState?.companyInstance?.urlServer;

	return async (dispatch) => {
		await db.collection("meetings").add({
			rutDoctor: data.rutDoctor,
			rutPatient: data.rutPatient,
			emailPatient: emailPatient,
			//phonePatient: phonePatient,
			start_time: data.start_time,
			start_time2: data.start_time2,
			url_meet: data.url_meet,
			validation: true
		}).then((doc) => {
			//Realiza la acción que coincida con ese type
			dispatch({ type: types.addLinkPeritaje });
			// LLama la función para guardar el Log de adición de tipo de plan medico
			enviarLogReservaPerito(types.addLinkPeritaje, uid, doc.id)

			const dataEmail = {
				email: emailPatient,
				namePatient: data.namePatient,
				nameDoctor: data.nameDoctor,
				date: data.datePeritaje,
				time: data.time,
				url_meet: data.url_meet
			}

			axios.post(`${urlServer}/mails/sendMail`, dataEmail)
				.then((response) => {
					if (response.status === 200) {
						alertOK("Se guardó el Link de la Llamada y se Notificó al Paciente")
					}
				})
				.catch((err) => {
					enviarLogErrorReservaPerito(types.resendLink, err.code, uid);
					alertFAIL("Error al Enviar el Link de la Videollamada");
				});
		}).catch((error) => {
			//Realiza la acción que coincida con ese type
			dispatch({ type: types.addLinkPeritaje });
			// LLama la función para guardar el Log de adición de link para el peritaje
			enviarLogErrorReservaPerito(types.addLinkPeritaje, error.code, uid);
			alertFAIL("Error al Agregar el Link de la Video Llamada");
		});
	}
}

export const addLinkPeritajeNew = (uid, data) => {
	const reduxState = store.getState().company;
	const db = reduxState?.companyInstance?.db;
	const urlServer = reduxState?.companyInstance?.urlServer;

	return async (dispatch) => {
		await db.collection("meet_peritaje").doc(data.idDocument).update({
			emailPatient: data.emailPatient,
			statusPeritaje: "Agendado",
			urlMeet: data.url_meet,
		}).then((doc) => {
			//Realiza la acción que coincida con ese type
			dispatch({ type: types.addLinkPeritaje });
			// LLama la función para guardar el Log de adición de tipo de plan medico
			enviarLogReservaPerito(types.addLinkPeritaje, uid, data.idDocument)

			const dataEmail = {
				email: data.emailPatient,
				namePatient: data.namePatient,
				nameDoctor: data.nameDoctor,
				date: data.datePeritaje,
				time: data.time,
				url_meet: data.url_meet
			}

			axios.post(`${urlServer}/mails/sendMail`, dataEmail)
				.then((response) => {
					if (response.status === 200) {
						alertOK("Se guardó el Link de la Llamada y se notificó al Paciente")
					}
				})
				.catch((err) => {
					enviarLogErrorReservaPerito(types.resendLink, err.code, uid);
					alertFAIL("Error al Enviar el Link de la Videollamada");
				});
		}).catch((error) => {
			//Realiza la acción que coincida con ese type
			dispatch({ type: types.addLinkPeritaje });
			// LLama la función para guardar el Log de adición de link para el peritaje
			enviarLogErrorReservaPerito(types.addLinkPeritaje, error.code, uid);
			alertFAIL("Error al Agregar el Link de la Video Llamada");
		});
	}
}

export const resendLink = (uid, data, flag) => {
	const reduxState = store.getState().company;
	const db = reduxState?.companyInstance?.db;
	const urlServer = reduxState?.companyInstance?.urlServer;

	const isaprePeritaje = data.isapre ? data.isapre.toUpperCase().trim() : 'CONSALUD';
	return async (dispatch) => {

		db.collection("config")
			.doc("configApp")
			.collection("peritaje")
			.onSnapshot(
				(snapshot) => {
					let resIsaprePeritaje;
					snapshot.forEach((doc) => {
						if (doc.id === "isapre") {
							resIsaprePeritaje = new Map(Object.entries(doc.data()));
						}
					});

					const dataIsapre = resIsaprePeritaje.get(
						isaprePeritaje.toLowerCase()
					);

					db.collection('meet_peritaje').doc(data.idDocument).update({
						addressEmailSend: data.emailPatient,
					}).then((doc) => {
						//Realiza la acción que coincida con ese type
						dispatch({ type: types.resendLink });
						// LLama la función para guardar el Log de adición de tipo de plan medico
						enviarLogReservaPerito(types.resendLink, uid, data.idDocument)

						const dataEmail = {
							email: data.emailPatient,
							namePatient: data.namePatient,
							nameDoctor: data.nameDoctor,
							date: data.datePeritaje,
							time: data.time,
							url_meet: data.url_meet,
							isapre: isaprePeritaje,
							dataIsapre: { ...dataIsapre }
						}
						console.log("nombre del doctor: ", data.nameDoctor);

						axios.post(`${urlServer}/mails/sendMail`, dataEmail)
							.then((response) => {
								if (response.status === 200) {
									//Realiza la acción que coincida con ese type
									dispatch({ type: types.resendLink });
									// LLama la función para guardar el Log de adición de link para el peritaje
									enviarLogReservaPerito(types.resendLink, uid, data.idDocument);
									if (flag === "reenviar") {
										alertOK("El reenvío del correo al paciente fue exitoso");
									}
								}
							})
							.catch((err) => {
								enviarLogErrorReservaPerito(types.resendLink, err.code, uid);
								alertFAIL("Error al reenviar el correo al paciente");
							});

					}).catch((error) => {
						//Realiza la acción que coincida con ese type
						dispatch({ type: types.resendLink });
						// LLama la función para guardar el Log de adición de link para el peritaje
						enviarLogErrorReservaPerito(types.resendLink, error.code, uid);
						alertFAIL("Error al agregar el link de la Video Llamada");
					});

				},
				(error) => { }
			);
	}
}
/**
 * Envía un email al paciente con la información de la cita
 * @param {*} data información de la cita
 * @returns alerta indicando que el email se envió correctamente o error en caso contrario
 */
export const sendEmailPeritaje = (data, dataIsapre) => {
	const reduxState = store.getState().company;
	const urlServer = reduxState?.companyInstance?.urlServer;

	console.log("entra al sendEmailPeritaje (data a revisar)", data);
	const newTimestamp = getTimeStampCorregidoZonaHorariaCH(new Date(data.timestamp), data.timeZone);
	const datePeritaje = moment(
		new Date(newTimestamp)
	).locale('es').format("dddd, D MMMM YYYY, h:mma").split(",");
	const datePeritajeP = datePeritaje[0].trim() + ", " + datePeritaje[1].trim();
	const timePeritaje = datePeritaje[2].trim();

	const dataEmail = {
		email: data.emailPatient,
		namePatient: data.namePatient,
		nameDoctor: data.nameDoctor,
		date: datePeritajeP,
		time: timePeritaje,
		url_meet: data.url_meet,
		isapre: data.isapre.toUpperCase().trim(),
		dataIsapre: { ...dataIsapre }
	}

	axios.post(`${urlServer}/mails/sendMail`, dataEmail)
		.then((response) => {
			if (response.status === 200) {
				// alertOK("El envío del correo al paciente fue exitoso");
				console.log("El envío del correo al paciente fue exitoso");
			}
		})
		.catch((err) => {
			alertFAIL("Error al enviar el correo al paciente");
		});

}

export const sendLinkManual = (uid, data) => {
	const reduxState = store.getState().company;
	const db = reduxState?.companyInstance?.db;
	const urlServer = reduxState?.companyInstance?.urlServer;

	const date_aux = data.start_time2.replace("T", " ").replaceAll("-", " ").replace(":", " ").replace("  ", "").split(" ");
	const time_aux = new Date(date_aux[0], (parseInt(date_aux[1]) - 1), date_aux[2], date_aux[3], date_aux[4]);
	const time_aux_setmore = date_aux[0] + "-" + date_aux[1] + "-" + date_aux[2] + "T" + date_aux[3] + ":" + (date_aux[4] === "00" ? date_aux[4] : date_aux[4] === "20" ? "15" : "30") + "Z";

	moment.locale('es');

	const time_format = moment(time_aux).locale('es').format('dddd, D MMMM YYYY, h:mma');
	const d = time_format.split(",");
	const datePeritajeP = d[0] + ", " + d[1];
	const timePeritaje = d[2];

	return async (dispatch) => {
		await db.collection("meetings").add({
			rutDoctor: data.rutDoctor,
			rutPatient: data.rutPatient,
			emailPatient: data.email,
			start_time: time_format,
			start_time2: time_aux_setmore,
			url_meet: data.link,
			validation: true
		}).then((doc) => {
			//Realiza la acción que coincida con ese type
			dispatch({ type: types.addLinkPeritaje });
			// LLama la función para guardar el Log de adición de tipo de plan medico
			enviarLogReservaPerito(types.addLinkPeritaje, uid, doc.id)

			const dataEmail = {
				email: data.email,
				namePatient: data.namePatient,
				nameDoctor: data.nameDoctor,
				date: datePeritajeP,
				time: timePeritaje,
				url_meet: data.link
			}

			axios.post(`${urlServer}/mails/sendMail`, dataEmail)
				.then((response) => {
					if (response.status === 200) {
						alertOK("Se guardó el Link de la Llamada y se Notificó al Paciente")
					}
				})
				.catch((err) => {
					enviarLogErrorReservaPerito(types.resendLink, err.code, uid);
					alertFAIL("Error al Enviar el Link de la Videollamada");
				});
		}).catch((error) => {
			//Realiza la acción que coincida con ese type
			dispatch({ type: types.addLinkPeritaje });
			// LLama la función para guardar el Log de adición de link para el peritaje
			enviarLogErrorReservaPerito(types.addLinkPeritaje, error.code, uid);
			alertFAIL("Error al Agregar el Link de la Video Llamada");
		});
	}
}

export const sendLinksFromExcel = (uid, data) => {
	const reduxState = store.getState().company;
	const db = reduxState?.companyInstance?.db;
	const urlServer = reduxState?.companyInstance?.urlServer;

	const date_aux = data.date.replaceAll("/", " ").split(" ");
	const time_aux = new Date(date_aux[2], (parseInt(date_aux[1]) - 1), date_aux[0], data.hour, data.minute);
	const time_aux_setmore = date_aux[2] + "-" + (date_aux[1] < 10 ? ("0" + date_aux[1]) : date_aux[1]) + "-" + (date_aux[0] < 10 ? ("0" + date_aux[0]) : date_aux[0]) + "T" + data.hour + ":" + (data.minute === 0 ? "00" : data.minute === 20 ? "15" : "30") + "Z";

	moment.locale('es');

	const time_format = moment(time_aux).locale('es').format('dddd, D MMMM YYYY, h:mma');
	const d = time_format.split(",");
	const datePeritajeP = d[0] + "," + d[1];
	const timePeritaje = d[2];

	return async (dispatch) => {

		await db.collection("meetings").add({
			rutDoctor: data.rutDoctor,
			rutPatient: data.rutPatient,
			emailPatient: data.email,
			start_time: time_format,
			start_time2: time_aux_setmore,
			url_meet: data.link,
			validation: true
		}).then((doc) => {
			//Realiza la acción que coincida con ese type
			dispatch({ type: types.addLinkPeritaje });
			// LLama la función para guardar el Log de adición de tipo de plan medico
			enviarLogReservaPerito(types.addLinkPeritaje, uid, doc.id)

			const dataEmail = {
				email: data.email,
				namePatient: data.namePatient,
				nameDoctor: data.nameDoctor,
				date: datePeritajeP,
				time: timePeritaje,
				url_meet: data.link
			}

			axios.post(`${urlServer}/mails/sendMail`, dataEmail)
				.then((response) => {
					if (response.status === 200) {

						db.collection("emails_send").add({
							rutDoctor: data.rutDoctor,
							nameDoctor: data.nameDoctor,
							rutPatient: data.rutPatient,
							namePatient: data.namePatient,
							email: data.email,
							date: datePeritajeP,
							time: timePeritaje,
							url_meet: data.link,
							date_send: new Date()
						}).then((doc) => {
						}).catch((err) => {
							alertFAIL("Error al Guardar el Registro del envío del Link de la Videollamada");
						})
					}
				})
				.catch((err) => {
					enviarLogErrorReservaPerito(types.resendLink, err.code, uid);
					alertFAIL("Error al Enviar el Link de la Videollamada");
				});

		}).catch((error) => {
			//Realiza la acción que coincida con ese type
			dispatch({ type: types.addLinkPeritaje });
			// LLama la función para guardar el Log de adición de link para el peritaje
			enviarLogErrorReservaPerito(types.addLinkPeritaje, error.code, uid);
			alertFAIL("Error al Agregar el Link de la Video Llamada");
		});

	}
}

export const metodoMateo = (data, url, isapre) => {
	const reduxState = store.getState().company;
	const db = reduxState?.companyInstance?.db;
	const urlServer = reduxState?.companyInstance?.urlServer;
	console.log("data: ", data)

	const time_aux = new Date(data.timestamp);

	// const timeWithZoneFromExcel = new Date(data.timestamp).toLocaleString("en-ES", {
	// 	timeZone: data.Zona,
	// });

	moment.locale('es');

	const time_format = moment.tz(time_aux, data.timeZone).locale('es').format('dddd, D MMMM YYYY, h:mma');
	const d = time_format.split(",");
	const datePeritajeP = d[0] + "," + d[1];
	const timePeritaje = d[2];

	return async (dispatch) => {

		//Realiza la acción que coincida con ese type
		dispatch({ type: types.addLinkPeritaje });

		const URL_PAGE = url + window.btoa(unescape(encodeURIComponent(data.idDocument)));

		const dataEmail = {
			email: data.emailPatient !== "" ? data.emailPatient : data.emailPatientAux,
			namePatient: data.namePatient,
			nameDoctor: data.nameDoctor,
			date: datePeritajeP,
			time: timePeritaje,
			url_meet: URL_PAGE,
			isapre: data.isapre.toUpperCase().trim(),
			dataIsapre: { ...isapre }
		}

		console.log(dataEmail)

		if (dataEmail.email !== "" && dataEmail.url_meet !== "") {

			axios.post(`${urlServer}/mails/sendMail`, dataEmail)
				.then((response) => {

					if (response.status === 200) {

						db.collection("meet_peritaje").doc(data.idDocument).update({
							statusPeritaje: "Agendado",
							dateSendEmail: new Date().toUTCString(),
							addressEmailSend: dataEmail.email,
						}).then((doc) => {
							// //Realiza la acción que coincida con ese type
							dispatch({ type: types.addLinkPeritaje });
							// // LLama la función para guardar el Log de adición de tipo de plan medico
							// enviarLogReservaPerito(types.addLinkPeritaje, uid, data.timestamp)
						}).catch((error) => {
							//Realiza la acción que coincida con ese type
							dispatch({ type: types.addLinkPeritaje });
							console.log("No dio")
							// LLama la función para guardar el Log de adición de link para el peritaje
							// enviarLogErrorReservaPerito(types.addLinkPeritaje, error.code, uid);
							alertFAIL("Error al Agregar el Link de la Video Llamada");
						});

					}
				}).catch((err) => {
					console.log(err);
					// enviarLogErrorReservaPerito(types.resendLink, err.code, uid);
					alertFAIL("Error al Enviar el Link de la Videollamada");
				});
		}

	}
}

export const sendLinksFromExcelNew = (uid, data, urlSalaPerito) => {

	const date_aux = data.date.replaceAll("/", " ").split(" ");
	const time_aux = new Date(date_aux[2], (parseInt(date_aux[1]) - 1), date_aux[0], data.hour, data.minute);
	// const time_aux_setmore = date_aux[2] + "-" + (date_aux[1] < 10 ? ("0" + date_aux[1]) : date_aux[1]) + "-" + (date_aux[0] < 10 ? ("0" + date_aux[0]) : date_aux[0]) + "T" + data.hour + ":" + (data.minute === 0 ? "00" : data.minute === 20 ? "15" : "30") + "Z";

	moment.locale('es');

	const time_format = moment(time_aux).locale('es').format('dddd, D MMMM YYYY, h:mma');
	const d = time_format.split(",");
	const datePeritajeP = d[0] + "," + d[1];
	const timePeritaje = d[2];
	// const dayMonth = datePeritajeP.replace(",", "").split(" ")[1]

	return async (dispatch) => {

		//Realiza la acción que coincida con ese type
		dispatch({ type: types.addLinkPeritaje });

		const dataEmail = {
			email: data.Correo !== undefined ? data.Correo : data.Correo_Contacto,
			namePatient: data.Paciente,
			nameDoctor: data.Doctor,
			date: datePeritajeP,
			time: timePeritaje,
			// url_meet: data.link,
			url_meet: urlSalaPerito,
		}

		console.log(dataEmail)

		// if (dataEmail.email !== "" && dataEmail.url_meet !== "") {
		// 	axios.post(`${urlServer}/sendMail"`, dataEmail)
		// 		.then((response) => {
		// 			if (response.status === 200) {

		// 				db.collection("meet_peritaje").doc(data.idDocument).update({
		// 					dateSendEmail: new Date().toUTCString(),
		// 					addressEmailSend: dataEmail.email,
		// 				}).then((doc) => {
		// 					// //Realiza la acción que coincida con ese type
		// 					dispatch({ type: types.addLinkPeritaje });
		// 					// // LLama la función para guardar el Log de adición de tipo de plan medico
		// 					// enviarLogReservaPerito(types.addLinkPeritaje, uid, data.timestamp)
		// 				}).catch((error) => {
		// 					//Realiza la acción que coincida con ese type
		// 					dispatch({ type: types.addLinkPeritaje });
		// 					// LLama la función para guardar el Log de adición de link para el peritaje
		// 					// enviarLogErrorReservaPerito(types.addLinkPeritaje, error.code, uid);
		// 					alertFAIL("Error al Agregar el Link de la Video Llamada");
		// 				});

		// 			}
		// 		}).catch((err) => {
		// 			console.log(err);
		// 			// enviarLogErrorReservaPerito(types.resendLink, err.code, uid);
		// 			alertFAIL("Error al Enviar el Link de la Videollamada");
		// 		});
		// }

	}
}

//Método para iniciar la limpieza del Estado
export const startCleanDatesReserva = () => {
	return async (dispatch) => {
		dispatch(cleanDatesReserva());
	}
}

//Método que llama el type para limpiar el Estado
export const cleanDatesReserva = () => ({
	type: types.cleanDatesPeritaje
})

//Método para guardar el Log de Admin para los diferentes módulos designados para este rol
const enviarLogReservaPerito = (type, uid, id) => {
	const reduxState = store.getState().company;
	const db = reduxState?.companyInstance?.db;

	//Se crea la fecha actual en la que se crea el Log
	let date = new Date();

	//Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
	db.collection("log")
		.add({
			log_date: date,
			action: type,
			user: uid,
			meeting_id: id
		})
		.then((docRef) => {
		})
		.catch((error) => {
			console.error("Error adding document: ", error);
		});
};

//Método para guardar el Log de los errores de Auth para iniciar sesión, cerrar sesión, olvidar contraseña y register
const enviarLogErrorReservaPerito = (action, error, uid) => {
	const reduxState = store.getState().company;
	const db = reduxState?.companyInstance?.db;

	//Se crea la fecha actual en la que se crea el Log
	let date = new Date();

	//Se registra en la colección el Log, almacenando la fecha de la acción, la acción, el error obtenido y el email que originó el error
	db.collection("log")
		.add({
			log_date: date,
			action: action,
			error: error,
			user: uid
		})
		.then((docRef) => {

		})
		.catch((error) => {
			console.error("Error adding document: ", error);
		});

}
/////////////////////////////////////////////////////MÉTODOS PARA LOGS/////////////////////////////////////////////////////


/////////////////////////////////////////////////////MÉTODOS PARA ALERTAS/////////////////////////////////////////////////////
//Método para la alerta cuando fue con éxito una acción
const alertOK = (title) => {
	Swal.fire({
		position: 'center',
		icon: 'success',
		title: title,
		showConfirmButton: false,
		allowOutsideClick: false,
		timer: 1300,
		showClass: {
			popup: 'animate__animated animate__fadeInUp'
		},
		hideClass: {
			popup: 'animate__animated animate__fadeOutDown'
		}
	})
}

//Método para la alerta cuando fracasó una acción
const alertFAIL = (msg) => {
	Swal.fire({
		icon: 'error',
		title: 'Oops...',
		text: msg,
		showClass: {
			popup: 'animate__animated animate__fadeInDown'
		},
		hideClass: {
			popup: 'animate__animated animate__fadeOutDown'
		}
	})
}
/////////////////////////////////////////////////////MÉTODOS PARA ALERTAS/////////////////////////////////////////////////////